import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/lib/css-base'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import ActionFavorites from '~root/src/components/ActionFavorites.vue?shadow'
window.customElements.define('esco-action-favorites', wrap(Vue, ActionFavorites))

import ContentFavorites from '~root/src/components/ContentFavorites.vue?shadow'
window.customElements.define('esco-content-favorites', wrap(Vue, ContentFavorites))

import ContentGrid from '~root/src/components/ContentGrid.vue?shadow'
window.customElements.define('esco-content-grid', wrap(Vue, ContentGrid))

import ContentGridFilter from '~root/src/components/ContentGridFilter.vue?shadow'
window.customElements.define('esco-content-grid-filter', wrap(Vue, ContentGridFilter))

import ContentMenu from '~root/src/components/ContentMenu.vue?shadow'
window.customElements.define('esco-content-menu', wrap(Vue, ContentMenu))

import ContentUser from '~root/src/components/ContentUser.vue?shadow'
window.customElements.define('esco-content-user', wrap(Vue, ContentUser))

import Ellipsis from '~root/src/components/Ellipsis.vue?shadow'
window.customElements.define('esco-ellipsis', wrap(Vue, Ellipsis))

import HamburgerMenu from '~root/src/components/HamburgerMenu.vue?shadow'
window.customElements.define('esco-hamburger-menu', wrap(Vue, HamburgerMenu))

import HeaderButtons from '~root/src/components/HeaderButtons.vue?shadow'
window.customElements.define('esco-header-buttons', wrap(Vue, HeaderButtons))

import PortletCard from '~root/src/components/PortletCard.vue?shadow'
window.customElements.define('esco-portlet-card', wrap(Vue, PortletCard))